<div *ngIf="(detalharLaudoService.detalharPontuacaoCandidato$ | async) as pontuacoes; else carregando">
	<div *ngIf="pontuacoes.length > 0; else semDados">
		<div *ngFor="let pontuacao of pontuacoes">
			<div *ngFor="let atividade of pontuacao.atividades" class="br-card mt-4">
				<div class="card-header" style="background-color: #071d41; padding: 12px 16px">
					<span class="text-semi-bold text-up-02" style="color: #ffffff">Atividade: {{ atividade.nomeAtividade }}</span>
				</div>
				<div class="card-content">
					<div class="br-table" *ngIf="atividade.notas.length > 0; else semNotas">
						<table>
							<thead>
								<tr>
									<th>Critério</th>
									<th>Nome da Área</th>
									<th>Match Com</th>
									<th class="text-center">Anos de Experiência</th>
									<th class="text-center">Pontuação da Área</th>
									<th class="text-center">Pontuação Considerada</th>
									<th class="text-center">Match Desconsiderado</th>
									<th class="text-center">Pontuação Obtida</th>
									<th class="text-center" *ngIf="isPesquisador && situacaoLaudo === 'GER'">Ações</th>
								</tr>
							</thead>
							<tbody>
								<tr
									*ngFor="let nota of atividade.notas; let i = index"
									[style.background-color]="i % 2 === 0 ? '#f8f8f8' : '#ffffff'"
								>
									<td>{{ nota.nomeCriterio }}</td>
									<td>{{ nota.nomeArea }}</td>
									<td>{{ nota.matchCom }}</td>
									<td class="text-center">{{ nota.anosExperiencia !== null ? nota.anosExperiencia : '-' }}</td>
									<td class="text-center">{{ nota.pontuacaoArea | number:'1.1-2' }}</td>
									<td class="text-center">
										<span *ngIf="nota.pontuacaoConsiderada" class="text-success">Sim</span>
										<span *ngIf="!nota.pontuacaoConsiderada" class="text-danger">Não</span>
									</td>
									<td class="text-center"
									[title]="nota.matchDesconsiderado ? 'Desconsiderado por ' + nota.nomePesquisador + ' em ' + nota.dataHoraDesconsideracaoMatch : ''"
									>
										<span *ngIf="nota.matchDesconsiderado" class="text-danger">Sim</span>
										<span *ngIf="!nota.matchDesconsiderado" class="text-success">Não</span>
									</td>
									<td class="text-center">{{ nota.pontuacaoObtida | number:'1.1-2' }}</td>
									<td class="text-center" *ngIf="isPesquisador && situacaoLaudo === 'GER'">
										<button
											pButton
											class="br-button circle"
											title="Desconsiderar Match"
											icon="fas fa-ban"
											[disabled]="nota.matchDesconsiderado"
											(click)="desconsiderarMatch(nota)"
										></button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<ng-template #semNotas>
						<p class="mt-2 text-base">Nenhuma pontuação curricular encontrada para esta atividade.</p>
					</ng-template>

					<div class="br-divider mt-3 mb-3"></div>

					<div class="row">
						<div class="col-md-6">
							<p class="mb-1">
								<span class="text-semi-bold">A. Total Graduação:</span> {{ atividade.totalGraduacao | number:'1.1-2' }}
								&nbsp;&nbsp; <span class="text-semi-bold">Pontuação Final:</span> {{ atividade.totalGraduacaoFinal |
								number:'1.1-2' }}
							</p>
							<p class="mb-1">
								<span class="text-semi-bold">B. Total Pós Graduação, Mestrado ou Doutorado:</span> {{ atividade.totalPos |
								number:'1.1-2' }} &nbsp;&nbsp; <span class="text-semi-bold">Pontuação Final:</span> {{
								atividade.totalPosFinal | number:'1.1-2' }}
							</p>
							<p class="mb-1">
								<span class="text-semi-bold">C. Total Cursos, Treinamentos, Workshops:</span> {{ atividade.totalCursos |
								number:'1.1-2' }} &nbsp;&nbsp; <span class="text-semi-bold">Pontuação Final:</span> {{
								atividade.totalCursosFinal | number:'1.1-2' }}
							</p>
							<p class="mb-1">
								<span class="text-semi-bold">D. Pontuação Formação Acadêmica (A + B + C):</span> {{
								atividade.totalPontuacaoFormacao | number:'1.1-2' }}
							</p>
						</div>
						<div class="col-md-6">
							<p class="mb-1">
								<span class="text-semi-bold">E. Pontuação Experiência:</span> {{ atividade.totalPontuacaoExperiencia |
								number:'1.1-2' }}
							</p>
							<p class="mb-1">
								<span class="text-semi-bold">F. Pontuação Interesse:</span> {{ atividade.totalPontuacaoInteresse |
								number:'1.1-2' }}
							</p>
							<p class="mb-1">
								<span class="text-semi-bold">G. Pontuação Questionário:</span> {{ atividade.totalPontuacaoQuestionario |
								number:'1.1-2' }}
							</p>
							<p class="mb-1 text-up-01">
								<span class="text-semi-bold">H. Pontuação Geral (G + ((D + E) / 2) + F):</span>
								<span class="text-semi-bold"> {{ atividade.totalPontuacaoGeral | number:'1.1-2' }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<ng-template #semDados>
		<div class="br-card mt-4">
			<div class="card-content">
				<p>Nenhuma pontuação encontrada para este candidato.</p>
			</div>
		</div>
	</ng-template>
</div>

<p-confirmDialog acceptLabel="Confirmar" rejectLabel="Cancelar"></p-confirmDialog>

<ng-template #carregando>
	<div class="text-center mt-4">
		<i class="fas fa-spinner fa-spin text-up-03"></i>
		<span class="ml-2">Carregando pontuação...</span>
	</div>
</ng-template>
